<script>
export default {
	methods: {
		formatStartDate(date) {
			if (date) {
				const normalizedDate = new Date(date);

				normalizedDate.setHours(0);
				normalizedDate.setMinutes(0);
				normalizedDate.setSeconds(0);
				normalizedDate.setMilliseconds(0);

				return normalizedDate.toISOString();
			}

			return null;
		},
		formatEndDate(date) {
			if (date) {
				const normalizedDate = new Date(date);

				normalizedDate.setHours(23);
				normalizedDate.setMinutes(59);
				normalizedDate.setSeconds(59);
				normalizedDate.setMilliseconds(999);

				return normalizedDate.toISOString();
			}

			return null;
		}
	}
};
</script>
